module.exports = __webpack_public_path__ + "static/media/at2b.faf9de43.jpg";